// WP-5.3 (M18 MF-1/2, S-26 `/explorer`): a straight passthrough query to `GET /api/v1/flow`.
import type { CurrencyCode } from '@pfos/engine';
import { moneyFlowResponseSchema, type MoneyFlowResponse } from '@pfos/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from './api';

export interface MoneyFlowFilters {
  currency: CurrencyCode;
  from: string;
  to: string;
}

export function useMoneyFlow(filters: MoneyFlowFilters): UseQueryResult<MoneyFlowResponse> {
  const params = new URLSearchParams({
    currency: filters.currency,
    from: filters.from,
    to: filters.to,
  });
  return useQuery({
    queryKey: ['flow', filters],
    queryFn: async () =>
      moneyFlowResponseSchema.parse(await api.get(`/api/v1/flow?${params.toString()}`)),
  });
}
